import { findRule, getNested } from '../Utils';

const validate = (vObj) => {
  //console.log(vObj)
  const { value } = vObj; // val of current field
  //console.log(value)
  const rule = findRule(vObj.errorBag, 'same_as');
  rule.feedback = `This should match ${vObj.fieldlabel}`;
  const { errorBag } = vObj;
  const params = findRule(errorBag, 'same_as').ruleParams.split(',');

  const requiredField = params[0]; // other field name
  //console.log(requiredField)

  let requiredFieldVal;

  if (requiredField.includes('.')) {
    requiredFieldVal = getNested(vObj.vnode.context, requiredField);
  } else {
    requiredFieldVal = vObj.vnode.context[requiredField]; // value of other field
  }
  //console.log(requiredFieldVal)

  const required = value === requiredFieldVal;

  return required;
};

export { validate };

export default {
  validate,
};
